// eslint-disable-next-line
export default  {
    apiKey: "AIzaSyDBqCuZfvhza7lSPX-QqcoiYdQc8ufEEOE",
    authDomain: "college-webapp.firebaseapp.com",
    projectId: "college-webapp",
    storageBucket: "college-webapp.appspot.com",
    messagingSenderId: "1033593528582",
    appId: "1:1033593528582:web:1bd55c894b66bf97aa3e87",
    measurementId: "G-TKBBN6Q8WH"
  };